import * as React from "react";
import { IdentityClaims } from "~/domain/tokens";

export type AuthenticationContextProps = {
  identity: IdentityClaims | null;
  platformOptedInCookie: string | null;
  isVendrInternalEmployee: boolean;
  isSyntheticTest: boolean;
  isAuthenticatedWithVendrPlatform: boolean;
};

export const defaultAuthenticationContextProps: AuthenticationContextProps = {
  identity: null,
  platformOptedInCookie: null,
  isVendrInternalEmployee: false,
  isSyntheticTest: false,
  isAuthenticatedWithVendrPlatform: false,
};

export const AuthenticationContext =
  React.createContext<AuthenticationContextProps>(
    defaultAuthenticationContextProps,
  );
